import { useEffect, useState } from "react";
import HottestRecruitmentQuestionList from "../../components/recruitment-question/HottestRecruitmentQuestionList/HottestRecruitmentQuestionList";
import RecruitmentQuestionAllQuestionsTable from "../../components/recruitment-question/RecruitmentQuestionAllQuestionsTable/RecruitmentQuestionAllQuestionsTable";
import RecruitmentQuestionRecommendListCard from "../../components/recruitment-question/RecruitmentQuestionRecommendListCard/RecruitmentQuestionRecommendListCard";
import "./recruitment_question_set.scss";
import httpclient from "../../service/httpclient";
import { Badge, Spin } from "antd";
import RecruitmentQuestionMembershipCard from "../../components/recruitment-question/RecruitmentQuestionMembershipCard/RecruitmentQuestionMembershipCard";
import useWindowWidth from "../../hooks/useWindowWidth";

function RecruitmentQuestionSet() {
  const [questionLists, setQuestionLists] = useState(null);
  const fetchQuestionLists = () =>
    httpclient.getAllVisibleRecruitmentQuestionLists().then((res) => {
      setQuestionLists(res);
    });
  useEffect(() => {
    fetchQuestionLists();
  }, []);

  const [hasMembership, setHasMembership] = useState(true);
  useEffect(() => {
    httpclient.possessProductMembership(1, false).then((res) => {
      setHasMembership(!!res.result);
    });
  }, []);

  const { windowWidth } = useWindowWidth();

  return (
    <div className="recruitment-question-set">
      <div className="recruitment-question-set-wrapper">
        <div id="membership">
          {/* <div className="section-header">
            <div className="section-title">获取会员</div>
          </div> */}
          <div className="section-container">
            <RecruitmentQuestionMembershipCard props={hasMembership} />
          </div>
        </div>
        <div
          id="recommend-list"
          style={{
            gridColumn: windowWidth > 898 ? "1 / 2" : "1 / 3",
          }}
        >
          {/* <div className="section-header">
            <div className="section-title">推荐题单</div>
          </div> */}
          <div className="section-container">
            {questionLists ? (
              questionLists.map((list) => (
                <div key={list.title} className="card-item">
                  {list.can_take_exam ? (
                    <Badge.Ribbon text="可模拟笔试">
                      <RecruitmentQuestionRecommendListCard list={list} />
                    </Badge.Ribbon>
                  ) : (
                    <RecruitmentQuestionRecommendListCard list={list} />
                  )}
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", width: "100%" }}>
                <Spin />
              </div>
            )}
          </div>
        </div>
        <div id="hottest-questions">
          <div className="section-header">
            <div className="section-title">热门题目</div>
          </div>
          <div className="section-container">
            <HottestRecruitmentQuestionList />
          </div>
        </div>
        <div id="all-questions">
          <div className="section-header">
            <div className="section-title">全部题目</div>
          </div>
          <div className="section-container">
            <RecruitmentQuestionAllQuestionsTable />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecruitmentQuestionSet;
